<template>
    <div class="client-list" v-if="status === 'loaded'">
        <div class="admin-page text-center">
            <the-nav>
                <h1>Clientes</h1>

                <div class="buttons-container">
                    <button class="btn btn-danger icon-wrapper"
                            @click="emptyFilters">
                        <i class="uq-icon bi-filter"></i>&nbsp;Limpiar filtros
                    </button>

                    <button class="btn btn-download icon-wrapper"
                            v-if="can('export.clients')"
                            @click="downloadClients(filters)">
                        <i class="uq-icon bi-download"></i>
                    </button>

                    <button class="btn btn-secondary" type="button" @click="this.modalToShow = 'add-client'"
                            title="Nuevo usuario" v-if="can('client.store')">
                        <span>Añadir cliente</span>
                    </button>
                </div>
            </the-nav>

            <div class="row form-container" v-if="can('client.index')">
                <div class="col-2 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Nº cliente: </label>
                        <input type="text" class="form-control" aria-label="Código cliente" v-model="filters.code"
                               @input="search"/>
                    </div>
                </div>

                <div class="col-3 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Nombre: </label>
                        <input type="text" class="form-control" aria-label="Nombre" v-model="filters.name"
                               @input="search"/>
                    </div>
                </div>

                <div class="col-2 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Teléfono: </label>
                        <input type="text" class="form-control" aria-label="Teléfono" v-model="filters.phone"
                               @input="search"/>
                    </div>
                </div>

                <div class="col-3 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Correo electrónico: </label>
                        <input type="text" class="form-control" aria-label="Correo electrónico" v-model="filters.email"
                               @input="search"/>
                    </div>
                </div>

                <div class="col-2 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">DNI/NIE: </label>
                        <input type="text" class="form-control" aria-label="DNI/NIE" v-model="filters.dni"
                               @input="search"/>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <v-table :meta="clients.meta" :pagination="clients.links.pagination" @pageChanged="pageChanged">
                        <template v-slot:header>
                            <th>Número del cliente</th>
                            <th>Nombre</th>
                            <th>Apellidos</th>
                            <th>DNI/NIE</th>
                            <th>Teléfono</th>
                            <th>Correo electrónico</th>
                            <th>Localidad</th>
                            <th class="fit" colspan="2">Acciones</th>
                        </template>

                        <template v-slot:body>
                            <tr v-for="client in clients.data">
                                <td>{{ client.code }}</td>
                                <td>{{ client.name }}</td>
                                <td>{{ client.surname }}</td>
                                <td>{{ client.dni }}</td>
                                <td>{{ getPhoneNumbers(client) }}</td>
                                <td>{{ getEmails(client) }}</td>
                                <td>{{ client.location }}</td>

                                <td class="fit">
                                    <div class="actions-container">
                                        <button class="btn btn-show" @click="showClient(client)"
                                                v-if="can('client.show')">
                                            <i class="uq-icon bi-eye"></i>
                                        </button>

                                        <button class="btn btn-edit" @click="editClient(client)"
                                                v-if="can('client.update')">
                                            <i class="uq-icon bi-pencil"></i>
                                        </button>

                                        <!--                                        <button class="btn btn-delete" @click="deleteClient(client)"-->
                                        <!--                                                v-if="can('client.destroy')">-->
                                        <!--                                            <i class="uq-icon bi-trash"></i>-->
                                        <!--                                        </button>-->
                                    </div>
                                </td>

                                <td class="fit">
                                    <div class="actions-container">
                                        <button class="btn btn-danger" @click="goToCreateExpedient(client.id)"
                                                v-if="can('expedient.store')">
                                            Crear expediente
                                        </button>

                                        <button class="btn btn-warning" @click="goToClientExpedients(client.id)"
                                                v-if="can('expedient.index')">
                                            Ver expedientes
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <tr v-if="!clients.data">
                                <td colspan="222222">No hay clientes</td>
                            </tr>
                        </template>
                    </v-table>

                    <div v-if="status === 'loading'">
                        <div class="loader-container">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <clients-list-show-modal v-if="modalToShow === 'show-client'" :client="selectedClient"
                             @closed="modalToShow = null"></clients-list-show-modal>
    <clients-list-edit-modal v-if="modalToShow === 'edit-client'" :client="selectedClient"
                             @closed="modalToShow = null; loadClients()"></clients-list-edit-modal>
    <clients-list-delete-modal v-if="modalToShow === 'delete-client'" :client="selectedClient"
                               @closed="modalToShow = null; loadClients()"></clients-list-delete-modal>
    <clients-list-add-modal v-if="modalToShow === 'add-client'"
                            @closed="modalToShow = null; loadClients()"></clients-list-add-modal>
</template>

<script>
import ClientsListShowModal from "./parts/ClientsListShowModal";
import ClientsListEditModal from "./parts/ClientsListEditModal";
import ClientsListDeleteModal from "./parts/ClientsListDeleteModal";
import ClientsListAddModal from "./parts/ClientsListAddModal";
import {can} from "../../helpers/Permissions";
import router from "../../router";
import {getClientsPaginated} from "../../helpers/requests/RequestsClients";
import {withTimeout} from "../../helpers/requests/RequestsCore";
import TheNav from "../layouts/TheNav";
import {downloadClientsXLSX} from "../../helpers/Exports";
import VPagination from "../general/VPagination";
import {filtersToQueryParameters, setQueryParameters} from "../../helpers/Url";
import VTable from "../general/VTable";

export default {
    name: "general",
    components: {
        VPagination,
        TheNav,
        ClientsListAddModal,
        ClientsListDeleteModal,
        ClientsListEditModal,
        ClientsListShowModal,
        VTable
    },
    setup() {
        return {
            can,
            downloadClientsXLSX,
        }
    },
    data() {
        return {
            status: 'loading',
            clients: [],
            selectedClient: null,
            client: null,
            clientId: null,
            modalToShow: null,
            user_permissions: window.permissions,

            do_search: true,

            filters: {
                code: '',
                phone: '',
                email: '',
                name: '',
                dni: '',
                page: 1,
            },
            timers: {
                search: '',
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user.userLogged;
        }
    },
    async mounted() {
        window.$ = window.jQuery = require('jquery');

        // Read query params to form filters
        await this.setQueryParametersAsFilters();
        await this.doSearch();
        this.status = 'loaded';
    },
    watch: {
        $route(to, from) {
            // Apply only if we are operating over the same view
            if (to.name === from.name) {
                // TODO: Watch this and just only change url query parameters when methods fire something? This will do the rest
                this.setQueryParametersAsFilters();

                // We force it to not search because of a two-requests problem
                if (this.do_search === true) {
                    this.doSearch();
                }

                this.do_search = true;
            }
        }
    },
    methods: {
        downloadClients(filters) {
            this.$store.dispatch('app/setToastMessage', 'Procesando la descarga...');
            downloadClientsXLSX(filters);
        },
        getPhoneNumbers(client) {
            if (!!client.phone_number_01 && !!client.phone_number_02) {
                return client.phone_number_01 + '/' + client.phone_number_02;
            } else if (!!client.phone_number_01) {
                return client.phone_number_01;
            } else if (!!client.phone_number_02) {
                return client.phone_number_02;
            }
        },
        getEmails(client) {
            if (!!client.email_01 && !!client.email_02) {
                return client.email_01 + '/' + client.email_02;
            } else if (!!client.email_01) {
                return client.email_01;
            } else if (!!client.email_02) {
                return client.email_02;
            }
        },
        async doSearch() {
            this.do_search = false;
            await this.setFiltersAsQueryParameters();
            await this.loadClients();
        },
        emptyFilters() {
            this.filters = {
                code: '',
                phone: '',
                email: '',
                name: '',
                dni: '',
                page: 1,
            };

            this.doSearch();
        },
        /**
         * Detects any query parameter in the url and loads it in the filters (if available)
         *
         * @returns {Promise<void>}
         */
        async setQueryParametersAsFilters() {
            let query_parameters = router.currentRoute.value.query;

            if (query_parameters.code) {
                this.filters.code = query_parameters.code;
            } else {
                this.filters.code = '';
            }
            if (query_parameters.phone) {
                this.filters.phone = query_parameters.phone;
            } else {
                this.filters.phone = '';
            }
            if (query_parameters.email) {
                this.filters.email = query_parameters.email;
            } else {
                this.filters.email = '';
            }
            if (query_parameters.name) {
                this.filters.name = query_parameters.name;
            } else {
                this.filters.name = '';
            }
            if (query_parameters.dni) {
                this.filters.dni = query_parameters.dni;
            } else {
                this.filters.dni = '';
            }
            if (query_parameters.page) {
                this.filters.page = query_parameters.page;
            } else {
                this.filters.page = 1;
            }
        },
        /**
         * Sets the local filters as url query parameters.
         */
        setFiltersAsQueryParameters() {
            setQueryParameters('client.index', this.filters);
        },
        async loadClients() {
            let query = filtersToQueryParameters(this.filters);

            this.clients = await getClientsPaginated(query);
        },
        search() {
            this.timers.search = withTimeout(async () => {
                this.filters.page = 1;
                await this.doSearch();
            }, this.timers.search, 250);
        },
        async pageChanged(page) {
            this.filters.page = page;
            await this.doSearch();
        },
        showClient(client) {
            this.modalToShow = 'show-client';
            this.selectedClient = client;
        },
        editClient(client) {
            this.modalToShow = 'edit-client';
            this.selectedClient = client;
        },
        deleteClient(client) {
            this.modalToShow = 'delete-client';
            this.selectedClient = client;
        },
        addClient() {
            this.modalToShow = 'add-client';
        },
        async goToCreateExpedient(client_id) {
            let query = {
                createExpedient: 'true',
                client: client_id + ''
            };

            await router.push({
                name: 'expedient.index',
                query: query
            });
        },
        async goToClientExpedients(client_id) {
            let query = {
                client: client_id + ''
            }

            await router.push({
                name: 'expedient.index',
                query: query
            });
        },
    },
    unmounted() {
        delete window.$;
        delete window.jQuery;
    }
}
</script>
